module.exports = __webpack_public_path__ + "img/map_marker.5e639807.svg";